import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container, Accordion } from 'react-bootstrap';
import ContratoService from '../../../../services/contrato';
import { Link } from 'react-router-dom';
import Exportar from '../../../../components/shared/export'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';



const FormBusca = (props) => {
    const [processo, setProcesso] = useState("");
    const [situacao, setSituacao] = useState("");
    const [unidadeGestora, setUnidadeGestora] = useState("");
    const [ano, setAno] = useState("");
    const [numero, setNumero] = useState("");
    const [contratado, setContratado] = useState("");
    const [cnpj, setCnpj] = useState("");


    const busca = async (query) => {
        if (query === "") {
            await props.fetchContratosIn()
            setProcesso("")
            setAno("")
            setNumero("")
            setContratado("")
            setCnpj("")
        } else {
            var response = await ContratoService.buscar(query)
            if (response.data.length >= 1) {
                props.setContratos(response.data)
                props.setVazio(false)
                setProcesso("")
                setAno("")
                setNumero("")
                setContratado("")
                setCnpj("")
            } else {
                props.setVazio(true)
                setProcesso("")
                setNumero("")
                setContratado("")
                setCnpj("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (situacao !== "false" && situacao !== "") prepQuery = prepQuery + `&situacao=${encodeURI(situacao)}`;
        if (numero) prepQuery = prepQuery + `&numero=${numero}`;
        if (unidadeGestora !== "false" && unidadeGestora !== "") prepQuery = prepQuery + `&unidadeGestora=${encodeURI(unidadeGestora)}`;
        if (contratado) prepQuery = prepQuery + `&contratado=${encodeURI(contratado)}`;
        if (cnpj) prepQuery = prepQuery + `&cnpj=${cnpj}`;
        if (ano) prepQuery = prepQuery + `&ano=${ano}`;
        if (processo) prepQuery = prepQuery + `&processo=${processo}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={5}>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="processo">
                                <FloatingLabel
                                    label="Número do Processo (sem ano)"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="processo"
                                        value={processo}
                                        onChange={e => setProcesso(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="ano"
                                        value={ano}
                                        onChange={e => setAno(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="numero">
                                <FloatingLabel
                                    label="Número do Contrato"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="numero"
                                        value={numero}
                                        onChange={e => setNumero(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="contratante">
                                <FloatingLabel
                                    label="Contratante"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Contratante"
                                        name="unidadeGestora"
                                        onChange={e => setUnidadeGestora(e.target.value)}
                                    >
                                        <option value="false">TODAS</option>
                                        <option value="Prefeitura de Macuco">Prefeitura Municipal de Macuco</option>
                                        <option value="Fundo Municipal de Saúde">Fundo Municipal de Saúde</option>
                                        <option value="Fundo Municipal da Educação">Fundo Municipal da Educação</option>
                                        <option value="Fundo Municipal de Assistência Social">Fundo Municipal de Assistência Social</option>
                                        <option value="Fundo Municipal da Criança e do Adolescente">Fundo Municipal da Criança e do Adolescente</option>
                                        <option value="Fundo Municipal de Meio Ambiente">Fundo Municipal de Meio Ambiente</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="Situação">
                                <FloatingLabel
                                    label="Situação"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Situação"
                                        name="situacao"
                                        onChange={e => setSituacao(e.target.value)}
                                    >
                                        <option value="false">TODAS</option>
                                        <option value="Ativo">Ativo</option>
                                        <option value="Concluído">Concluído</option>
                                        <option value="Cancelado">Cancelado</option>
                                        <option value="Rescindido">Rescindido</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={5}>
                            <Form.Group className="mb-3" controlId="contratado">
                                <FloatingLabel
                                    label="Razão Social do Contratado"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="contratado"
                                        value={contratado}
                                        onChange={e => setContratado(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={5}>
                            <Form.Group className="mb-3" controlId="cnpj">
                                <FloatingLabel
                                    label="CPF/CNPJ"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="cnpj"
                                        value={cnpj}
                                        onChange={e => setCnpj(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/contratos'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                     <Accordion>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header><strong>Dados Abertos <FontAwesomeIcon icon={faDatabase} /></strong></Accordion.Header>
                            <Accordion.Body>
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <Exportar data={props.contratos} nome={"Chamamentos"} />
                                    </Col>
                                </Row>
                                <br />
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <a href="https://documenter.getpostman.com/view/19738229/2sA3BrWp4P#54b2c850-e331-4b8f-bce0-866020944cea" target='_blank'>
                                            <Button>API e sua documentação</Button>
                                        </a>
                                    </Col>
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca